<template>
  <div class="calculate-wrap">
    <!-- 정산 버튼 누르기 전 -->
    <section class="calculate-area">
      <template>
        <div class="price estimated" v-if="calcPrice.calc_price !== '' || null">
          <p class="payback">
            <span class="step">정산 예정 금액</span>
            <span class="number">{{
              calcPrice.calc_price == undefined
                ? 0
                : calcPrice.calc_price | currency
            }}</span>
            원

            <!-- 
            this.calculateComment.deny: 정산조건이 충족되지 않은 경우 메시지
            this.calculateComment.end: 정산 신청 기간이 마감된 경우 메시지
            -->
            <button
              v-tooltip.bottom="!possbleDate?this.calculateComment.end:this.calculateComment.deny"
              class="show-tooltip"
              v-if="(possbleDate && calcPrice.calc_aval_yn != 'Y') || !possbleDate"
            >
              <img src="@/assets/images/icon-tooltip.svg" alt="" />
            </button>
          </p>
        </div>
        <span
          class="bar"
          v-if="
            calcPrice.pending_price !== undefined &&
              calcPrice.pending_price !== '0'
          "
        ></span>
        <div
          class="price"
          v-if="
            calcPrice.pending_price !== undefined &&
              calcPrice.pending_price !== '0'
          "
        >
          <p class="price-title">
            <img src="@/assets/images/icon-money.svg" alt="" />정산 금액
          </p>
          <p class="payback">
            <span class="step">정산 진행 중</span>
            <span class="number">{{
              calcPrice.pending_price == undefined
                ? 0
                : calcPrice.pending_price | currency
            }}</span>
            원
          </p>
        </div>
        <reseller-button
          v-if="calcPrice.calc_aval_yn == 'Y' && possbleDate"
          type="primary"
          size="large"
          class="m-l-30"
          @click="$_showModal()"
          >정산신청
        </reseller-button>
      </template>
    </section>
  </div>
</template>

<script>
import { $EventBus } from '@/utils/EventBus';
export default {
  /* data() {
    return {
      calcPrice: this.$attrs.calcPrice
    };
  }, */

  data() {
    return {
      calculateComment: {
        deny:
          '정산 조건이 충족되지 않아 정산 신청이 불가한 상태입니다. <br>조건이 충족되지 않으나 정산 희망 시 담당자에게 연락해주세요.',
        end:
          '정산 신청 가능 기한이 아닙니다. <br>매월 3일부터 7일 사이 정산 신청이 가능합니다.'
      }
    };
  },

  filters: {
    currency(value) {
      return parseFloat(value)
        .toFixed(0)
        .replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, '$1,');
    }
  },
  props: {
    calcPrice: {
      type: Object,
      required: true
    }
  },
  computed: {
    possbleDate() {
      const toDay = new Date();
      if (toDay.getDate() == 3 && toDay.getHours() < 10) {
        return false;
      }
      return toDay.getDate() >= 3 && toDay.getDate() <= 7 ? true : false;
    }
  },
  mounted() {
    /* const toDay = new Date();
    let test = toDay.getDate() >= 2 && toDay.getDate() <= 25 ? true : false;
    console.log(test); */
  },
  methods: {
    $_showModal() {
      $EventBus.$emit('show-modal', true);
    }
  }
};
</script>

<style lang="scss" scoped>
.show-tooltip {
  background: transparent;
  margin-left: 10px;
  position: relative;
  top: -3px;
}
</style>
